import React from "react";
import { Box, Text, UnstyledButton } from "@mantine/core";
import { DESIGN_ICONS } from "../../../../theme/designIcons";
import styles from "./SummaryRow.module.css";

interface SummaryRowProps {
  label: string;
  /** Shown next to the label; omitted when undefined. No subtext. */
  count?: number;
  /** Opens the row's nested screen. */
  onOpen: () => void;
}

const ChevronRight = DESIGN_ICONS.ChevronRight;

/**
 * A drawer row that links to a nested screen (design handoff "Drawer
 * rules"): label + count only, e.g. "Forms 3", never a status breakdown.
 */
export default function SummaryRow({ label, count, onOpen }: SummaryRowProps) {
  return (
    <UnstyledButton className={styles.row} onClick={onOpen}>
      <Text component="span" className={styles.label}>
        {label}
      </Text>
      {count !== undefined && (
        <Text component="span" className={styles.count}>
          {count}
        </Text>
      )}
      <Box component="span" className={styles.chevron}>
        <ChevronRight size={16} />
      </Box>
    </UnstyledButton>
  );
}
